import { DocxExportNoticePhase } from '@/agent-v2/docx-export/schemas'
import type { AgentV2Message } from '@/agent-v2/store/reducer'

/**
 * Drops each export's "in progress" notice once its ready or failed notice is in the chat, so an
 * export shows one card at a time. The conversation keeps both notices; only the view collapses.
 */
export function withoutSettledDocxExportStarts(messages: AgentV2Message[]): AgentV2Message[] {
  const settledExportIds = new Set(
    messages.flatMap((message) => (message.docxExport && message.docxExport.phase !== DocxExportNoticePhase.STARTED ? [message.docxExport.export_id] : []))
  )
  if (settledExportIds.size === 0) return messages
  return messages.filter((message) => !(message.docxExport?.phase === DocxExportNoticePhase.STARTED && settledExportIds.has(message.docxExport.export_id)))
}
